import TYPES from '../actions/types';

const INITIAL_STATE = {
    list: [],
    paging: {},
    selected: null
};

export const areaReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TYPES.SET_AREAS:
            const { count, current, page, pageCount, sort, direction } = action.payload.paging;
            return {
                ...state, 
                list: action.payload.list, 
                paging: { count, current, page, pageCount, sort, direction }
            };

        case TYPES.SELECT_AREA:
            return {
                ...state,
                selected: action.payload
            };

        default:
            return state;
    }
};